// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1GKCZ","label":"LabeledBox_label__WLx1G"};